export default __webpack_public_path__ + "static/media/_Kuvempu.467006c3.jpg";